module.exports = __webpack_public_path__ + "cba0dd5fa1a5a54aae23f078f23aa22f.svg";